import React, { Component } from 'react';
import './NewAutocreatePage.css';
import '@shopify/polaris/dist/styles.css';
import {AppProvider} from '@shopify/polaris';
import Autocreate from '../components/Autocreate';
import { getFetch } from '../helpers/request';

interface NewAutocreatePageProps { }

interface NewAutocreatePageState {
  shopOrigin: string
}

class NewAutocreatePage extends Component <NewAutocreatePageProps, NewAutocreatePageState> {

  constructor(props: NewAutocreatePageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    //check if log in
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => res.json()
    ).then(data => {
      this.setState({ shopOrigin: data.shop_origin })
    }).catch(err => {

    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Autocreate type="new"></Autocreate>
      </AppProvider>
    );
  }
}

export default NewAutocreatePage;
